import axios from './index';

export const fetchTickets = async (page, limit, filters = {}, sort = undefined) => {
  const { data } = await axios.get('/tickets/admin', { params: { page, limit, sort, ...filters } });
  return data.data;
};

export const fetchTicketReplies = async (ticketId) => {
  const { data } = await axios.get(`/tickets/${ticketId}/replies/admin`);
  return data.data;
};

export const fetchTicketById = async (id) => {
  const { data } = await axios.get(`/tickets/${id}/admin`);
  return data.data;
};

export const replyTicket = async (ticketId, message) => {
  const { data } = await axios.post(`/tickets/reply/admin`, { ticketId, message });
  return data;
};

export const attachTicket = async (replyId, file) => {
  const formData = new FormData();
  formData.append('replyId', replyId);
  formData.append('file', file);

  const { data } = await axios.post(`/tickets/attach/admin`, formData, {
    timeout: 1000 * 60 * 3,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return data.messages;
};

export const updateTicket = async (id, payload) => {
  const { data } = await axios.put(`/tickets/admin`, { id, ...payload });
  return data.messages;
};

export const fetchTicketDepartments = async () => {
  const { data } = await axios.get(`/tickets/departments`);
  return data.data;
};

export const createTicket = async (payload) => {
  const { data } = await axios.post(`/tickets/admin`, payload);
  return data;
};
